/**
 * GLBLP-1354 — blog → product/collection click tracking.
 *
 * Fires a GA4 `blog_cta_click` event when a reader clicks from a blog article
 * through to a product or collection page.
 *
 * Delivery: `window.gtag`, which Elevar's app embed defines and wires to a
 * gtag.js instance configured for the b.box AU GA4 property. No GTM tag and no
 * GA4 configuration change is required for collection to begin.
 *
 * Listener is delegated on `document` (so it covers the article hero, the
 * product carousel and body copy with one script) and runs in the capture
 * phase (so carousel handlers that stop propagation cannot swallow it).
 */
(function () {
  'use strict';

  function linkType(pathname) {
    if (pathname.indexOf('/products/') !== -1) return 'product';
    if (pathname.indexOf('/collections/') !== -1) return 'collection';
    return null;
  }

  /**
   * Which article surface the link sits in, or null if it is outside the
   * article altogether (header nav, footer, cart drawer). Returning null is
   * what keeps ordinary site navigation out of the numbers — without it, a
   * header link to /collections/ would count as a blog CTA click.
   */
  function linkPosition(link) {
    if (link.closest('.article-hero')) return 'hero_cta';
    if (link.closest('.bts-carousel-card') || link.classList.contains('bts-carousel-card')) {
      return 'product_carousel';
    }
    if (link.closest('.article-content')) return 'article_body';
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        return;
      }

      // Same-origin only — external links are already covered by GA4's
      // built-in outbound click event, so tracking them here would duplicate.
      if (url.hostname !== window.location.hostname) return;

      var type = linkType(url.pathname);
      if (!type) return;

      // Only count links inside the article itself, not site navigation.
      var position = linkPosition(link);
      if (!position) return;

      if (typeof window.gtag !== 'function') return;

      window.gtag('event', 'blog_cta_click', {
        link_url: url.pathname,
        link_text: (link.textContent || '').trim().slice(0, 100),
        link_type: type,
        link_position: position,
        blog_article: window.location.pathname
      });
    },
    true
  );
})();
